import { IConfig } from "./Render";
export const Cube = ({width, height,children, stroke, stroke_width, fill }:IConfig)=>
{
    return (
        <g id="cube">
            {children}
        </g>
    );
}